import React from 'react';
import parse from 'html-react-parser'

function Skills(props) {

    const { data } = props

    return (
      <div className="skills card">
        {data.Skills.map((skill) => {
          return (
            <div key={skill.Area}>
              <div className="sk-title">
                <h4>{skill.Area}</h4>
              </div>
              <ul>
                {skill.SkillSet.map((skillDetail) => {
                  return (
                    <li key={skillDetail.Name}>
                      {parse(skillDetail.Name)}
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    );
  
}
export default Skills;
